const order = {
  state: {
    orderDetail: {}
  },
  mutations: {
    // 存储订单信息
    setOrderDetail(state, data) {
      state.orderDetail = data;
      sessionStorage.setItem("orderDetail", JSON.stringify(data)); //添加到sessionStorage
    },
    // 获取订单信息
    getOrderDetail(state, data) {
      state.orderDetail = JSON.parse(sessionStorage.getItem("orderDetail"));
    },
  }
}
export default order


// WEBPACK FOOTER //
// ./src/store/modules/order.js